import Profile from "./Profile"
export default [
    {
        path: "/profile",
        component: Profile,
        isProtected: true,
      },
]